import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ContentService } from 'src/app/shared/services/content/content.service';
import { content } from 'src/assets/content/fallback-content';

import { GatekeeperService } from '../../shared/services/gatekeeper/gatekeeper.service';
import { PersistentStorageService } from '../../shared/services/persistent-storage/persistent-storage.service';

const TABLET_BREAKPOINT = 1000;

interface CoachMarkContent {
  header: string;
  description: string;
}

@Component({
  selector: 'input-tabs-coachmark',
  standalone: true,
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './coach-mark.component.html',
  styleUrl: './coach-mark.component.scss',
})
export class InputTabsCoachmarkComponent implements OnInit, AfterViewInit {
  @Input() cookieName = 'FAS_RCC_Pref';
  @Input() flagName: string = '';

  coachMarkContent: CoachMarkContent = content.Data.v4_rcc_root.content.coachMark;

  @ViewChild('coachmarkTriggerButton') coachmarkTriggerButton?: ElementRef<HTMLButtonElement>;

  isVisible = true;
  theta = 90;

  constructor(
    private persistentStorage: PersistentStorageService,
    private gatekeeperService: GatekeeperService,
    private readonly contentService: ContentService,
  ) {
    this.contentService.getContent().subscribe((data) => {
      this.coachMarkContent = data.Data.v4_rcc_root.content.coachMark;
    });
  }

  ngOnInit(): void {
    this.theta = this.getTheta();

    if (!this.gatekeeperService.getToggleValue('rcc_coach_mark')) {
      this.isVisible = false;
      return;
    }

    const cookieValue = this.persistentStorage.getCookieJSON(this.cookieName)?.[this.flagName];

    if (cookieValue === true) {
      this.isVisible = false;
      this.persistentStorage.setCookieJSON(this.cookieName, this.flagName, true, 30);
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.coachmarkTriggerButton?.nativeElement?.click();
    }, 0);
  }

  @HostListener('window:resize')
  onResize(): void {
    this.theta = this.getTheta();
  }

  onClose(): void {
    this.persistentStorage.setCookieJSON(this.cookieName, this.flagName, true, 30);
    this.isVisible = false;
  }

  private getTheta(): number {
    if (typeof window === 'undefined') {
      return 90;
    }

    return window.innerWidth <= TABLET_BREAKPOINT ? 0 : 90;
  }
}
